module.exports = __webpack_public_path__ + "static/media/amex.a49b82f4.svg";